export default __webpack_public_path__ + "static/media/arrowright.9a7ab0f0.svg";